import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  dropDownWrapper: {
    "& svg": {
      width: "30px",
      height: "30px",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    backgroundColor: theme.palette.background.default,
  },
  boxWrapper: {
    width: "100%",
    padding: "50px 30px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    boxShadow:"0px 1px 4px rgba(0, 0, 0, 0.15);",
    [theme.breakpoints.up("md")]: {
      padding: "50px 80px",
    },
  },
  wrapper: {
    width: "100%",
    backgroundColor: theme.palette.common.white,
    maxWidth: "550px",
    margin: "auto",
    borderRadius: "4px",
    [theme.breakpoints.up("md")]: {
      width: "40%",
    },
  },
  carrefourWrapperLogo: {
    marginBottom: "15px",
    display:'flex',
    justifyContent:'center',
    "& svg": {
      width: "170px",
    },
    "& path:nth-of-type(2)": {
      fill: '#ee2527'
    }
  },
  loginText:{
    display:'flex',
    justifyContent:'center'
  }
}));
